import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Paper, Box, Button } from '@mui/material'

import { FormStatusType } from '@/enums/form-status.enum'
import {
  WalletsFormDialog,
  WalletsFilters,
  UiFeedbackWalletComponent,
  WalletsGeneralTableComponent,
} from '@/views/wallets/components'
import {
  useWalletsActions,
  useWalletsDialog,
  useWalletsFilters,
} from '@/views/wallets/hooks'
import { DialogsEnum } from '@/enums'

export const BonusWalletsByPlayerComponent = () => {
  const { t } = useTranslation()

  const { toggleDialog } = useWalletsDialog()

  const { handleChangeLimit, handleChangePage } = useWalletsFilters()

  const { setFormType } = useWalletsActions()

  const handleSetWallet = () => {
    setFormType(FormStatusType.CREATE)
    toggleDialog({
      open: true,
      id: DialogsEnum.DIALOG_MANUAL_BONUS,
    })
  }

  useEffect(() => {
    return () => {
      toggleDialog(false)
    }
  }, []) // eslint-disable-line

  return (
    <Box
      component={Paper}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      position="relative"
      borderRadius={2}
    >
      <Box p={2}>
        <WalletsFilters />
      </Box>
      <Box position="absolute" top="40px" right="16px">
        <Button onClick={handleSetWallet} variant="contained" color="primary">
          {t('wallet.setNewWallet')}
        </Button>
      </Box>
      <WalletsGeneralTableComponent
        handleChangeLimit={handleChangeLimit}
        handleChangePage={handleChangePage}
      />
      <UiFeedbackWalletComponent />
      <WalletsFormDialog />
    </Box>
  )
}
